import { observer } from "mobx-react";
import * as React from "react";
import { AppIcon } from "./AppIcon";

require("../../assets/css/components/Pager.css");

interface PagerProps {
  currentPage: number;
  totalCount: number; // número de itens retornados pela página atual
  onPageChange: (page: number) => void;
  pageSize?: number;
}

interface PagerState { }

@observer
export class PagerResultados extends React.Component<PagerProps, PagerState> {
  static defaultProps = {
    pageSize: 15,
  };

  render() {
    const { currentPage, totalCount, onPageChange, pageSize } = this.props;

    const totalPages = totalCount < pageSize ? currentPage : currentPage + 1; // se o totalCount for menor que pageSize, estamos na última página

    const handleClick = (page: number) => {
      // if (page >= 1 && (page < totalPages || (page === totalPages && totalCount === pageSize))) {
        onPageChange(page);
      // }
    };

    const renderPageNumbers = () => {
      const pageNumbers = [];
      const maxPagesToShow = 3;
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      let startPage = Math.max(currentPage - halfMaxPagesToShow, 1);
      let endPage = Math.min(currentPage + halfMaxPagesToShow, totalPages);

      if (currentPage <= halfMaxPagesToShow) {
        endPage = Math.min(maxPagesToShow, totalPages);
      } else if (currentPage + halfMaxPagesToShow >= totalPages) {
        startPage = Math.max(totalPages - maxPagesToShow + 1, 1);
      }

      if (startPage > 1) {
        pageNumbers.push(
          <button key={1} onClick={() => handleClick(1)} className={1 === currentPage ? 'active' : ''}>
            1
          </button>
        );
        if (startPage > 2) {
          pageNumbers.push(<button key="start-ellipsis" className="separador-pager" style={{ pointerEvents: "none" }}>...</button>);
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => handleClick(i)}
            className={i === currentPage ? 'active btn-pager' : 'btn-pager'}
          >
            {i}
          </button>
        );
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push(
            <button key="end-ellipsis" className="separador-pager" style={{ pointerEvents: "none" }}>...</button>
          );
        }
        pageNumbers.push(
          <button
            key={totalPages}
            onClick={() => handleClick(totalPages)}
            className={totalPages === currentPage ? 'active btn-pager' : 'btn-pager'}
          >
            {totalPages}
          </button>
        );
      }

      return pageNumbers;
    };

    return (
      
      <div className="pagination">
        <button onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 1} className="btn-ant border-right-custom">
          <AppIcon name="keyboard_arrow_left" size={14}/> Anterior
        </button>
        {renderPageNumbers()}
        <button onClick={() => handleClick(currentPage + 1)} disabled={totalCount < pageSize} className="btn-prox border-left-custom">
          Próximo <AppIcon name="keyboard_arrow_right" size={14}/>
        </button>
      </div>

    );
  }
}
